import * as React from 'react';
const SvgCircles = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_365_37606)">
      <path
        opacity={0.12}
        d="M4.66634 2.22534C2.67367 3.37804 1.33301 5.53252 1.33301 8.00013C1.33301 10.4677 2.67367 12.6222 4.66634 13.7749C6.65901 12.6222 7.99967 10.4677 7.99967 8.00013C7.99967 5.53252 6.65901 3.37804 4.66634 2.22534Z"
        fill="#0E0C0F"
      />
      <path
        d="M4.66634 13.7747C6.65901 12.622 7.99967 10.4675 7.99967 7.99992C7.99967 5.53231 6.65901 3.37783 4.66634 2.22513M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z"
        stroke="#0E0C0F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_365_37606">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCircles;
